import Version4 from './Version4.js'

export default {
  4: Version4
}
